import type { Translation } from "~/types/i18n";

export const zhTw: Translation = {
  nav: {
    top: "TOP",
    pv: "PV",
    introduction: "INTRODUCTION",
    character: "CHARACTER",
    news: "NEWS",
    goods: "GOODS",
    onair: "ON AIR",
    special: "SPECIAL",
  },
  hero: {
    comingSoon: "播出資訊即將公開",
    scrollDown: "SCROLL",
  },
  pv: {
    title: "PV",
    subtitle: "宣傳影片",
  },
  synopsis: {
    title: "STORY",
    subtitle: "劇情簡介",
  },
  characters: {
    title: "CHARACTER",
    subtitle: "角色介紹",
    cv: "聲優",
  },
  news: {
    title: "NEWS",
    subtitle: "最新消息",
    new: "NEW",
    noNews: "目前沒有新聞",
  },
  md: {
    title: "MD",
    subtitle: "官方周邊",
    visitStore: "前往商店",
    goBack: "返回",
    viewDetail: "查看詳情",
    buyNow: "去購買",
  },
  onair: {
    title: "ON AIR",
    subtitle: "播出資訊",
  },
  special: {
    title: "SPECIAL",
    subtitle: "特別內容",
  },
  footer: {
    policy: "隱私權政策",
    originals: "Laftel Originals",
    contact: "聯絡我們",
    share: "分享到X",
    copyright: "© 2025 Laftel Inc. All Rights Reserved.",
  },
  cta: {
    comingSoon: "即將推出",
  },
  home: {
    heroSubtitle: "Laftel打造的原創動畫",
    aboutTitle: "Empowering Fans Everywhere",
    aboutDescription:
      "We, Laftel, expand the diversity of the animation ecosystem by integrating production, investment, merchandise, and offline ventures based on subculture IPs.\nImmerse yourself in a new world of content through the captivating stories discovered by Laftel Originals.",
    worksTitle: "原創作品",
    comingSoon: "COMING SOON",
    navAbout: "ABOUT",
    navWorks: "WORKS",
    watchOnYoutube: "在YouTube觀看",
  },
};
